import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import styled from 'styled-components';

export const StyledDashboardContainer = styled.div`
  display: grid;
  height: 100%;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;

  > * {
    grid-column: 1;
    grid-row: 1;
  }
`;

export const StyledDashboardBase = styled.div`
  position: relative;
`;

export const StyledSmallLogo = styled.img`
  width: 76.5px;
  height: 36px;
`;

export const StyledHeaderContainer = styled.div`
  margin: 50px 30px 60px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledHomeMessageContainer = styled.div`
  font-family: Overpass;
  margin: auto 30px 30px 30px;
  color: white;
`

export const StyledWelcomeMessage = styled.p`
  font-family: Overpass;
  font-size: 14px;
  font-weight: 300;
  line-height: 16.38px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: white;
  margin: 0;
  margin-bottom: 10px;
`

export const StyledWelcomeHeading = styled.p`
  font-size: 32px;
  line-height: 36.8px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  margin: 0;
  font-weight: 300;
`

export const StyledChapterContainer = styled.div`
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-grow: 1;
`

export const StyledChapters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  justify-content: space-between;
  margin: 30px;
`
export const StyledChapterButton = styled(SvgIcon)`
  height: 50px;
  width: 50px;
  position: absolute;
  bottom: 0;
  right: 0;  
  padding: 10px;

`

export const StyledChapterBlockContainer = styled.div`
  position: relative;
  min-width: 150px;
  min-height: 178px;
  flex: 1 0 calc(50% - 10px);
  height: auto;
  background-color: #090909;
  border-radius: 12px;
  transition: background-color 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.primary.b};
    
    ${StyledChapterButton} ellipse {
      fill: #ffffff;    
    }
    ${StyledChapterButton} path {
      fill: #000000;    
    }
  }
`

export const StyledFullBlockContainer = styled(StyledChapterBlockContainer)`
  width: 100%;
  flex: unset;
`;

export const StyledChapterBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  padding: 0px 10px 10px 10px;
  height: 100%;
`
export const StyledChapterTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: start;
`

export const StyledChapterTime = styled.div`
  font-size: 11px;
  padding: 5px;
  background-color: white;
  color: black;
  border-radius: 0px 0px 3px 3px;
  font-weight: 700;
`

export const StyledChapterIcon = styled(SvgIcon)`
  margin-top: 10px;
`

export const StyledChapterTitleContainer = styled.div`
   display: flex;
  flexDirection: row; 
  alignItems: center;
  justifyContent: start; 
  width: 100%;
`

export const StyledChapterTitle = styled.p`
  margin: 0;
  font-size: 17px;
  font-weight: 300;
  color: white;
`

export const StyledUrgentHelpContentContainer = styled.div`
  margin: 15px;
  display: flex;
  flex-direction: row;

  svg {
    max-height: 100px;
  }
`;

export const StyledUrgentHelpContent = styled.div`
  width: 180px;
`;

export const Spacer = styled.div`
  flex-grow: 1;
`